import React from "react";
import PropTypes from "prop-types";
import withRouter from "./WithRouter";
import Format from "../../helpers/Format";
import MeAjudaComponent from "./MeAjudaComponent";

/**
 * Componente CommonButton
 *
 * @component
 * @param {Object} props - As propriedades do componente.
 * @param {ReactNode} props.children - O conteúdo a ser renderizado dentro do card.
 * @param {string} props.titulo - O título a ser exibido no topo da página.
 * @returns {ReactElement} O elemento React renderizado que representa o card.
 */
const Static = ({ children, titulo, path }) => {
  return (
    <div className="page-content">
      <div className="row">
        <div className="col-12">
          <div className="page-title d-sm-flex align-items-center justify-content-between">
            <h4 className="mb-sm-0 font-size-18">
              <MeAjudaComponent identificador={path}>
                {Format.capitalize(titulo)}
              </MeAjudaComponent>
            </h4>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-xl-12">
          <React.Fragment>{children}</React.Fragment>
        </div>
      </div>
    </div>
  );
};

Static.propTypes = {
  children: PropTypes.any,
  titulo: PropTypes.string,
  path: PropTypes.string,
};

export default withRouter(Static);
